import { createAction, createSlice } from "@reduxjs/toolkit";

const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      const { isSuccess, message } = action.payload;
      state.data = { isSuccess, message };
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      const { isSuccess, message } = action.payload;
      state.data = { isSuccess, message };
      state.processing = false;
      /* TODO: reducer for failure*/
    },
    reset(state) {
      state.data = null;
    },
  },
});

const { name, actions, reducer } = changePasswordSlice;
const changePasswordAction = createAction(name);
const resetChangePasswordAction = actions.reset;

export {
  changePasswordAction,
  resetChangePasswordAction,
  actions as changePasswordActions,
  reducer as changePasswordReducer,
};
